export function GetMockDevelopmentRead() {
  return {
    id: 1,
    name: "Kingsbourne",
    addedByUserId: 4,
    address: null,
    town: null,
    postcode: null,
    county: null,
    developerId: 1,
    emailAddress: "Alexander.Scott@justmortgages.co.uk",
    phoneNumber: "07587038943 ",
    mainContactName: "Alexander Scott",
    podAllocationId: 63,
    generalInfo: null,
    unitTypes: null,
    units: 0,
    createdDate: "0001-01-01T00:00:00",
    updatedDate: "2022-01-31T14:11:10.3400466",
    isDeleted: 0,
  };
}
